module.exports = __webpack_public_path__ + "img/HQ-OA-360V02TGL.f4b18f1c.jpg";